import { NavLink, Outlet, useLocation, Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { Home, Calendar, Footprints, FileText, CheckSquare, ClipboardList, MessageSquare, Dumbbell, User, LogOut, ExternalLink } from "lucide-react";

const TOP = [
  { to: "/guard", icon: Home, label: "Home", end: true },
  { to: "/guard/shifts", icon: Calendar, label: "Shifts" },
  { to: "/guard/tour", icon: Footprints, label: "Tour" },
  { to: "/guard/reports", icon: FileText, label: "Reports" },
  { to: "/guard/training", icon: Dumbbell, label: "Training" },
];
const MORE = [
  { to: "/guard/tasks", icon: CheckSquare, label: "Tasks" },
  { to: "/guard/post-orders", icon: ClipboardList, label: "Orders" },
  { to: "/guard/messenger", icon: MessageSquare, label: "Chat" },
  { to: "/guard/profile", icon: User, label: "Me" },
];
const ITEMS = [...TOP, ...MORE];

export const GuardLayout = () => {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const current = ITEMS.find(i => i.end ? loc.pathname === i.to : loc.pathname.startsWith(i.to)) || ITEMS[0];

  return (
    <div className="pwa-shell" style={{ paddingBottom: 84 }}>
      <header style={{
        padding: "16px 16px 12px", borderBottom: "1px solid var(--border-dark)",
        display: "flex", alignItems: "center", justifyContent: "space-between"
      }}>
        <Logo size={44} compact />
        <div className="flex items-center gap-3">
          <Link to="/" className="tap-target text-muted hover:text-white inline-flex items-center gap-1" style={{ fontSize: 12 }} data-testid="back-to-site-guard">
            <ExternalLink size={14} /> Site
          </Link>
          <button onClick={logout} className="tap-target" style={{ color: "#8CA0B8" }} data-testid="guard-logout">
            <LogOut size={18} />
          </button>
        </div>
      </header>

      <div style={{ padding: "16px 16px 24px" }}>
        <div style={{ fontSize: 13, color: "#8CA0B8" }}>{user?.name}</div>
        <div className="h-page">{current?.label}</div>
      </div>

      <div style={{ padding: "0 16px" }}>
        <Outlet />
      </div>

      <nav className="pwa-bottom-nav">
        {ITEMS.map(i => (
          <NavLink key={i.to} to={i.to} end={i.end}
                   className={({ isActive }) => `pwa-nav-item ${isActive ? "active" : ""}`}
                   data-testid={`gnav-${i.label}`}>
            <i.icon size={20} />
            <span>{i.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
